
import React from 'react'
import { connect } from 'react-redux'
import { Outlet } from 'react-router-dom'

import { withLegacyRouter } from '../../decorators'
import { getIdToken } from '../../lib/cognito'
import { ClientNameContext } from '../../lib/context/client-name'
import { PatientIdContext } from '../../lib/context/patient-id'
import { updateRoutes } from '../../lib/GlobalVars/actions'
import { BASE_URL } from '../../lib/http'
import { encounterSearch } from '../Encounter/actions'
import FABComponent from '../Header/FAB'
import AssessmentTimer from '../Header/FAB/AssessmentTimer'
import { getPractitioners } from '../Header/User/actions'
import { CircularProgress } from '../shared/NarusMaterial'

import { setClientName } from './actions'
import { ErrorPlaceHolder, NoDataPlaceHolder } from './behavioral/components'
import EncounterWarnings from './EncounterWarnings'
import { PatientViewer } from './patient-viewer'
import PatientBannerComponent from './PatientBanner'
import { getPatientBanner } from './PatientBanner/actions'
import { getGoals } from './Standard/Goals/Goals/actions'
// import { getAdmissions, getProcedures } from './Standard/MedicalHistory/Events/actions'

/**
 * @param {number} status
 */
function isValidStatus (status) {
  return status >= 200 && status < 300
}

function PageWrapper ({ children }) {
  return (
    <div style={{ padding: '1rem', height: 'calc(100% - 16.5rem)', display: 'flex', flexDirection: 'column' }}>
      {children}
    </div>
  )
}

class Assessment extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      patient: {
        status: null,
        isValidating: false,
        error: null
      }
    }

    this.checkAccess = this.checkAccess.bind(this)
  }

  componentDidMount () {
    const { dispatch, params, auth } = this.props
    this.checkAccess(() => {
      dispatch(setClientName(params.clientName))
      dispatch(updateRoutes(params))
      dispatch(getPatientBanner(params.clientName, params.id))
      dispatch(getGoals())
      dispatch(getPractitioners())
      dispatch(encounterSearch(params.id, auth.profile, params.clientName))
      // dispatch(getAdmissions(params.id))
      // dispatch(getProcedures(params.id))
    })
  }

  componentDidUpdate (prevProps, prevState) {
    let { params, auth, dispatch } = this.props

    if (
      prevProps.params?.clientName !== params?.clientName ||
      prevProps.params?.id !== params?.id
    ) {
      dispatch(getPatientBanner(params.clientName, params.id))
      this.checkAccess(() => {
        dispatch(updateRoutes(params))
        dispatch(encounterSearch(params.id, auth.profile, params.clientName))
      })
    }
  }

  /**
   * @param {() => void} [callback]
   */
  async checkAccess (callback) {
    let { params } = this.props

    this.setState(({ patient }) => ({
      patient: {
        ...patient,
        isValidating: true
      }
    }))

    let response

    try {
      let token = await getIdToken()

      response = await fetch(`${BASE_URL}/patients/${params.id}`, {
        method: 'HEAD',
        headers: {
          'Accept': 'application/json',
          'Authorization': `Bearer ${token}`,
          'X-Client-Name': params.clientName
        }
      })
    } catch (err) {
      this.setState(({ patient }) => ({
        patient: {
          ...patient,
          error: err,
          isValidating: false
        }
      }))

      return
    }

    let { status } = response

    this.setState(({ patient }) => ({
      patient: {
        ...patient,
        error: null,
        isValidating: false,
        status
      }
    }))

    if (!isValidStatus(status)) {
      return
    }

    callback?.()
  }

  renderFAB () {
    const { location, encounterNavBar, params } = this.props
    if (
      location &&
      location.pathname &&
      location.pathname.split('/').includes('report')
    ) {
      return null
    }
    if (!encounterNavBar.patientFolder) {
      return <AssessmentTimer />
    }
    return <FABComponent params={params} />
  }

  render () {
    let { params, auth } = this.props
    let { patient } = this.state
    let isClaimsHistoryDemo = this.props.location.pathname.endsWith('/_/claims-history')

    if (patient.error) {
      return (
        <PageWrapper>
          <ErrorPlaceHolder
            title='Error validating patient'
          />
        </PageWrapper>
      )
    }

    if (
      patient.isValidating ||
      patient.status === null
    ) {
      return (
        <PageWrapper>
          <CircularProgress />
        </PageWrapper>
      )
    }

    if (patient.status === 404) {
      return (
        <PageWrapper>
          <NoDataPlaceHolder
            title='Patient not found'
          />
        </PageWrapper>
      )
    }

    if (patient.status === 403) {
      return (
        <PageWrapper>
          <ErrorPlaceHolder
            title='You do not have permission to view this patient'
          />
        </PageWrapper>
      )
    }

    if (!isValidStatus(patient.status)) {
      return (
        <PageWrapper>
          <ErrorPlaceHolder
            title='Error validating patient'
          />
        </PageWrapper>
      )
    }

    if (isClaimsHistoryDemo) {
      return (
        <Outlet />
      )
    }

    return (
      <ClientNameContext.Provider value={params.clientName}>
        <PatientIdContext.Provider value={params.id}>
          <PatientViewer
            clientName={params.clientName}
            patientId={params.id}
          />

          <>
            <PatientBannerComponent sticky={false} />
            <div className='wrapper wide'>
              <div
                className='patient-folder-navigation'
                id='top'
              >
                <EncounterWarnings
                  params={params}
                  auth={auth}
                />
                {' '}
                {this.renderFAB()}
              </div>

              <Outlet />
            </div>
          </>
        </PatientIdContext.Provider>
      </ClientNameContext.Provider>
    )
  }
}

const mapStateToProps = redux => ({
  auth: redux.auth,
  encounterNavBar: redux.encounterNavBar,
  globalVars: redux.globalVars.params
})

export default connect(mapStateToProps)(withLegacyRouter(Assessment))
